import Switch from "react-switch";
import React from "react"


const Toggle = ({checked=true,name,onChange,id,label,disabled=false}) => {
    // const [checked, setChecked] = useState(false);
    // const handleChange = nextChecked => {
    //   setChecked(nextChecked);
    // };
  
    return (
      <div className="example">    
          <Switch  
            
             height ={20}
             width ={40}
             disabled={disabled}
             onChange={onChange}
             checked={checked}
             className="react-switch"
          />
          <span className ="ms-1">{name}</span>     
      </div>
    );
  };
  export default Toggle;
